// src/components/coaches/CoachRow.jsx
import React from "react";
import "./CoachRow.css";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { useHistory } from "react-router-dom";



export default function CoachRow({ coach, onEdit }) {
  const history = useHistory();
  // Full name
  const fullName =
    (coach.Name ? coach.Name : "") +
    " " +
    (coach.Surname ? coach.Surname : "");

  // Safe access for CoachDetail object
  const hasDetail = coach && coach.CoachDetail;

  const university = hasDetail && coach.CoachDetail.UniversityName
    ? coach.CoachDetail.UniversityName
    : "";

  const major = hasDetail && coach.CoachDetail.MajorName
    ? coach.CoachDetail.MajorName
    : "";

  const remainingSeats =
    hasDetail && coach.CoachDetail.RemainingSeats !== undefined
      ? coach.CoachDetail.RemainingSeats
      : 0;

  const totalSeats =  hasDetail && coach.CoachDetail.TotalSeat !== undefined
  ? coach.CoachDetail.TotalSeat
  : 0;

  const studentCount =    hasDetail && coach.CoachDetail.StudentCount !== undefined
  ? coach.CoachDetail.StudentCount
  : 0;

  

  // Safe ranks array
  const ranks =
    coach && coach.CoachRanks && coach.CoachRanks.length
      ? coach.CoachRanks
      : [];

  const isActive = totalSeats>0

  return (
    <tr className="coach-row" 
    onClick={()=> history.push(`/coaches/${coach.Id}`, { coach })  }
    >
      {/* Checkbox */}
      <td className="coach-row-checkbox">
        {/* <input type="checkbox" className="coach-row-checkbox-input" /> */}
        <div>
          {coach.Id}
        </div>
      </td>

      {/* Avatar + name + subtitle */}
      <td className="coach-row-name-cell">
        <div className="coach-row-name-wrapper">
          <div
            className="coach-row-avatar"
            style={{
              backgroundImage:
                "url(" + (coach.ProfilePictureUrl || "") + ")",
            }}
          ></div>

          <div className="coach-row-name-text">
            <div className="coach-row-fullname">{fullName}</div>
            <div className="coach-row-subtitle">
              {university} — {major}
            </div>
          </div>
        </div>
      </td>

      {/* Seats */}
      <td className="coach-row-seat-cell">
        <span className="coach-row-seats-badge">
          {studentCount}/{totalSeats}
        </span>
      </td>

      {/* Students */}
      {/* <td className="coach-row-body-cell">{studentCount}</td> */}

      {/* Rank chips */}
      <td className="coach-row-rank-cell">
        <div className="coach-row-rank-wrapper">
          {ranks.map(function (rank) {
            if(rank.VisibleOnPreview){

            return (
              <span key={rank.Id} className="coach-row-rank-chip">
                {rank.ExamSubType} — {rank.Rank}
              </span>
            );
          }

          })}
        </div>
      </td>

      {/* Status */}
      <td className="coach-row-status-cell">
        <span
          className={
            "coach-row-status " + (isActive ? "active" : "inactive")
          }
        >
          {isActive ? "Aktif" : "İnaktif"}
        </span>
      </td>

      {/* Actions */}
      <td className="coach-row-actions"
      onClick={(e) => {
        e.stopPropagation();   // 👈 THIS IS THE KEY
        onEdit(coach);
      }}
      >
        {/* <button className="coach-row-action-btn">
          <span className="material-symbols-outlined"><VisibilityIcon/></span>
        </button> */}

        <button
          className="coach-row-action-btn"
          
        >
          <span className="material-symbols-outlined"><EditIcon/></span>
        </button>

        {/* <button className="coach-row-action-btn">
          <span className="material-symbols-outlined">note_stack</span>
        </button> */}
      </td>
    </tr>
  );
}
